import React from 'react';
import {IndexRoute, Route} from 'react-router';

import App from './containers/app/App';
import MainPage from './containers/mainPage/MainPage';
import CategoryPage from './containers/categoryPage/CategoryPage';
import ProductPage from './containers/productPage/ProductPage';
import CheckoutPage from './containers/checkoutPage/CheckoutPage';
import OrderPage from './containers/orderPage/OrderPage';
import ContentPage from './containers/contentPage/ContentPage';

export default (
    <Route component={App}>
      <Route path="checkout" component={CheckoutPage}/>
      <Route path="order/:orderId/:orderToken" component={OrderPage}/>

      <Route path="page/**" component={ContentPage}/>
      <Route path="service/**" component={ProductPage}/>

      <Route path="/" component={MainPage}/>
      <Route path="/:mainTaxonSlug" component={MainPage}/>
      <Route path="/**" component={CategoryPage}/>
    </Route>
);



// WEBPACK FOOTER //
// ./routes.js